<template>
  <section>
    <b-container fluid>
      <b-row class="justify-content-center" id="wrap-footer">
        <b-col
          cols="11"
          sm="10"
          md="9"
          lg="8"
          class="text-center justify-content-center"
        >
          <b-container fluid>
            <b-row class="justify-content-center wrap-fcenter">
              <b-col
                cols="12"
                sm="9"
                class="text-left flex-column justify-content-center d-flex"
              >
                <!-- style="background: #fcc;" -->
                <img
                  src="@/assets/images/index/nav_logo1.png"
                  alt=""
                  class="logo-img"
                />
                <div class="copyright">
                  <div class="address">
                    <div>
                      <img
                        src="@/assets/images/index/mail-line.png"
                        alt=""
                        class="icon"
                      />
                      <span>caacic@caac.gov.cn</span>
                    </div>
                    <div>
                      <img
                        src="@/assets/images/index/map-pin-line.png"
                        alt=""
                        class="icon"
                      />
                      <span>北京市东城区东四西大街155号</span>
                    </div>
                  </div>
                  <div class="address1">
                    <span>ICP备案编号：京ICP备2021008775号-1</span>

                    <span
                      >Copyrights 中国民用航空局信息中心 All Rights
                      Reserved</span
                    >
                  </div>
                </div>
              </b-col>
              <b-col
                cols="12"
                sm="3"
                class="text-right flex-column justify-content-center d-flex"
              >
                <!-- style="background: #fefefe;" -->
                <img
                  src="@/assets/images/index/erCode.png"
                  alt=""
                  class="er-img"
                />
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
